import * as Sentry from '@sentry/react'

export const logCrumb = (crumb: Sentry.Breadcrumb) =>
  Sentry.addBreadcrumb(crumb)

export const logMsg = (
  message: string,
  level: Sentry.SeverityLevel = 'info',
  data?: Record<string, unknown>,
) => Sentry.captureMessage(message, { level, extra: data })

export const logErr = (e: unknown, ctx?: Record<string, unknown>) =>
  Sentry.captureException(e, { extra: ctx })
